import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
export class AppConfig {
    // tslint:disable-next-line: deprecation
    constructor(http) {
        this.http = http;
        this.config = null;
        this.env = null;
        this.configDirPath = 'config/';
        this.envFile = 'env.json';
    }
    /*
     * Use to get the data found in the second file (config file)
     */
    getConfig(key) {
        return this.config[key];
    }
    /*
     * Use to get the data found in the first file (env file)
     */
    getEnv(key) {
        return this.env[key];
    }
    /**
     * This method:
     *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
     *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
     */
    load() {
        return new Promise((resolve, reject) => {
            this.http
                .get(`${this.configDirPath}${this.envFile}?${Math.random()}`)
                .pipe(map((res) => {
                return res.json();
            }), catchError((error) => {
                console.log(`Configuration file '${this.configDirPath}${this.envFile}' could not be read`);
                resolve(true);
                // tslint:disable-next-line: deprecation
                return Observable.throw(error.json().error || 'Server error');
            }))
                .subscribe((envResponse) => {
                this.env = envResponse;
                let request = null;
                switch (envResponse.env) {
                    case 'prod':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'qa':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'tst':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'dev':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'local':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'default':
                        {
                            console.error('Environment file is not set or invalid');
                            resolve(true);
                        }
                        break;
                }
                if (request) {
                    request
                        .pipe(map((res) => {
                        return res.json();
                    }), catchError((error) => {
                        console.error(`Error reading '${envResponse.env}' configuration file.`);
                        resolve(error);
                        // tslint:disable-next-line: deprecation
                        return Observable.throw(error.json().error || 'Server error.');
                    }))
                        .subscribe(responseData => {
                        this.config = responseData;
                        //console.log(`[CONFIG] Loaded config.${envResponse.env}.json:`, responseData);
                        resolve(true);
                    });
                }
                else {
                    console.error('Env config file "env.json" is not valid.');
                    resolve(true);
                }
            });
        });
    }
}
AppConfig.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppConfig_Factory() { return new AppConfig(i0.ɵɵinject(i1.Http)); }, token: AppConfig, providedIn: "root" });
